import PreRegistrationService from "@/services/PreRegistrationService.js";
export const state = {
  journeyFlowID: null,
  compliance: {
    is_image_required: null,
    is_qr_included: null,
    is_face_id_included: null,
    is_rfid_included: null,
    is_compliance_required: null,
  },
};

export const mutations = {
  setJourneyFlowID(state, payload) {
    state.journeyFlowID = payload;
  },
};

export const actions = {
  setJourneyFlowID({ commit }, params) {
    commit("setJourneyFlowID", params);
  },
  getAreaDetails(params){
    return new Promise((resolve,reject) => {
      PreRegistrationService.getAreaDetails(params).then(response => {
        resolve(response.data);
      }).catch((err) => {
        reject(err);
      })
    })
  }
};

export const getters = {
  getJourneyFlowID(state) {
    return state.journeyFlowID;
  },
};
